export default __webpack_public_path__ + "static/media/ProMount_icon_green.e1233538.svg";